/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'Chevron-left': {
    width: 9,
    height: 14,
    viewBox: '0 0 9 14',
    data: '<path pid="0" d="M8.137 11.312c.481.458.481 1.2.016 1.674a1.21 1.21 0 01-.866.347c-.305 0-.61-.11-.835-.347L.853 7.507A1.174 1.174 0 01.5 6.671c0-.316.128-.616.353-.837l5.6-5.479a1.195 1.195 0 011.7 0 1.164 1.164 0 01-.016 1.674L3.404 6.67l4.733 4.641z" _fill="#001030"/>'
  }
})
